webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(2);

__webpack_require__(7);

__webpack_require__(9);

__webpack_require__(10);

/* Imports */
__webpack_require__(11);
// var WebFont = require('webfontloader');
// Necessary for IE11...
__webpack_require__(22);
__webpack_require__(23);

/* Load fonts via Google Fonts */
// WebFont.load({
//     google: {
//         families: ['Source Sans Pro', 'Montserrat']
//     }
// });

/* Custom scripts */
$(document).ready(function () {
    $('.js-logo-slider ').slick({
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: '.js-prev-arrow',
        nextArrow: '.js-next-arrow',
        responsive: [{
            breakpoint: 980,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }]
    });

    // document.querySelector('.js-button--play').addEventListener('click', () => document.querySelector('.js-audio-file').play());
    //
    // $('.js-sponsors').slick({
    //     autoplay: true,
    //     lazyLoad: 'ondemand',
    //     arrows: false,
    //     dots: true,
    //     slidesToShow: 4,
    //     slidesToScroll: 4,
    //     responsive: [
    //         {
    //             breakpoint: 1024,
    //             settings: {
    //                 slidesToShow: 4,
    //                 slidesToScroll: 4,
    //                 infinite: true,
    //                 dots: true
    //             }
    //         },
    //         {
    //             breakpoint: 980,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 3
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 2
    //             }
    //         }
    //     ]
    // });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(3);

__webpack_require__(4);

__webpack_require__(5);

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// require('../images/the-christmas-passion-crowd-small.jpg');
// require('../images/the-christmas-passion-crowd-medium.jpg');
// require('../images/the-christmas-passion-crowd-large.jpg');
// require('../images/the-christmas-passion-logo.svg');
// require('../images/the-christmas-passion-jumbotron-small.jpg');
// require('../images/the-christmas-passion-jumbotron-medium.jpg');
// require('../images/the-christmas-passion-jumbotron-large.jpg');
// require('../images/the-christmas-passion-header.svg');
// require('../images/example-logo-1.png');
// require('../images/example-logo-2.jpg');
// require('../images/example-logo-3.png');
// require('../images/example-logo-4.png');
// require('../images/example-logo-5.png');
// require('../images/twitter-icon.svg');
// require('../images/facebook-icon.svg');
// require('../images/instagram-icon.svg');
__webpack_require__(12);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(15);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(21);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/logo-otr.jpg";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/header7.jpg";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/werkplaats-example.jpg";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/service-example.jpg";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/example-logo-Peugeot.png";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/example-logo-Yamaha.png";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/example-logo.png";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/bovag-keurmerk.png";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/RDW-erkend.png";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/symbol-defs.svg";

/***/ })
],[1]);


// WEBPACK FOOTER //
// main.f0e81da3464b21cae18b.js